import { defineMessages } from 'react-intl'

const scope = 'procurify.core.features.RequestFeatureDemoButtonPresenter'

export default defineMessages({
  requestDemo: {
    id: `${scope}.requestDemo`,
    defaultMessage: 'Request demo',
  },
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Request sent',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Your Procurify account manager will be in touch shortly.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Something went wrong',
  },
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: "We couldn't send your request. Please try again.",
  },
  tooltipText: {
    id: `${scope}.tooltipText`,
    defaultMessage:
      'You have already requested access. We will reach out to you shortly.',
  },
})
